import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";


export const detailsPageApi = async (type) => {
  try {
    const response = await axios.get(`${baseUrl}details-pages?type=${type}`);
    return response;
  } catch (error) {


    return null;
  } finally {
  }
};
